const pinboardAction = (item) => {
  return {
    type: 'SET_SELECTED_ITEM',
    payload: item,
  }
}

export default pinboardAction
